import { useCallback, useEffect, useState } from "react";
import { listPages } from "../../../api/pagesApi";
import { listSections } from "../../../api/sectionsApi";
import { getApiErrorMessage } from "../../../api/unwrapApiResponse";

const INSIGHTS_SLUG = "insights";
const ARTICLES_SECTION_KEY = "articles";

export function useArticlesSection() {
  const [sectionId, setSectionId] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [pageName, setPageName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const resolve = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const pages = await listPages();
      const list = Array.isArray(pages) ? pages : [];
      const insightsPage =
        list.find((p) => (p.slug || "").toLowerCase() === INSIGHTS_SLUG) ||
        list.find((p) => (p.name || "").toLowerCase() === "insights");

      if (!insightsPage) {
        setError(
          'No Insights page found. Create a page with slug "insights" first.'
        );
        setSectionId(null);
        return;
      }

      const sections = await listSections(insightsPage.id);
      const sectionList = Array.isArray(sections) ? sections : [];
      const articlesSection =
        sectionList.find(
          (s) => (s.sectionType || "").toLowerCase() === "articles"
        ) ||
        sectionList.find(
          (s) => (s.key || "").toLowerCase() === ARTICLES_SECTION_KEY
        );

      if (!articlesSection) {
        setError(
          'No articles section found on the Insights page. Add a section with type "articles".'
        );
        setPageId(insightsPage.id);
        setPageName(insightsPage.name || "Insights");
        setSectionId(null);
        return;
      }

      setPageId(insightsPage.id);
      setPageName(insightsPage.name || "Insights");
      setSectionId(articlesSection.id);
      setSectionName(articlesSection.name || "Articles");
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    resolve();
  }, [resolve]);

  return {
    sectionId,
    pageId,
    pageName,
    sectionName,
    loading,
    error,
    reload: resolve,
  };
}
